<template>
  <div>
    <d-table
      v-if="tableReady"
      ref="customerTable"
      :data_object="data_object"
      :getFreshData="true"
      :serverPagination="true"
      :itemsPerPage="20"
      :alwaysUpdate="true"
      :rowClick="rowClick"
      :hasSearch="true"
      :searchLen="30"
      :noTabs="noTabs"
      :hideTopBar="false"
      :fields_excluded="fields_excluded"
      :editedItemTitle="editedItemTitle"
      tableName="customers"
      :columnTool="columnTool"
      :remoteSearch="remoteSearch"
      searchAfterCompleted="searchAfterCompleted"
      :remoteSearchFields="remoteSearchFields"
      :onDataReceived="onDataReceived"
      :minSearchLength="minSearchLength"
      :editRow="editRow"
      addButtonCaption="Add Customer"
      :hideEditedTabs="hideEditedTabs"
      :noCache="noCache"
      :beforeSave="beforeSave"
    />
  </div>
</template>
<script>
import axios from "axios";
import DTable from "../components/Table";
export default {
  components: {
    DTable,
    VCustomerInventory: () =>
      import("../components/dashboard/CustomerInventory.vue"),
  },
  data() {
    return {
      // fields_excluded: ["contact", "address", "comments"],

      noCache: true,
      editedItemTitle: ["customer_name"],
      data_object: {
        object_name: "v_customer_orders",

        object_name_to_update: "customer",
        all_records: true,
        item_key: "contact_id",
        table_title: "Customers",
      },
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      storageLink: { field: "storage_id", name: "storage" },
      remoteSearchFields: [
        "first_name",
        "last_name",
        "full_name",
        "customer_name",
        "email",
        "mobile_phone",
        "company",
      ],
      minSearchLength: 30,
      tableReady: false,
      remoteSearch: false,
      hasSearch: true,
      editRow: true,
      hideEditedTabs: false,
      noTabs: false,
      columnTool: true,
      searchAfterCompleted: true,
      customerTable: true,
      currentRecord: null,
      department: "",
      defaultModel: {},
    };
  },
  mounted() {
    // tableMounted
    var that = this;
    if (this.$root.customerId) {
      this.data_object.qry = {};
      this.data_object.qry._id = this.$root.customerId.$oid;
      this.data_object.id_fields = ["_id"];
      this.remoteSearch = false;
      this.editRow = true;
      this.hideEditedTabs = true;
      this.columnTool = false;
      this.noTabs = true;
      // this.noTabs = true;
      // this.noGroups = true;
    }
    this.$root.$on("tableMounted", (t) => {
      // console.log(t.k);
      if (t.k == "customer_shipments") {
        t.link = that.link;
        t.myLinkClick = that.linkClick;
      }
      if (t.k == "address") {
        t.data_object.schema.properties.existing_address.hidden = true;
      }
      if (t.k == "storage") {
        t.link = that.storageLink;
        t.myLinkClick = that.linkClick;
        // t.alwaysUpdate = true;
        that.defaultModel.customer = that.currentRecord;
        that.defaultModel.department = that.department;
        that.defaultModel.customer_name =
          that.currentRecord.type_of_customer == "commercial"
            ? that.currentRecord.company + " " + that.department
            : that.currentRecord.contact.first_name +
              " " +
              that.currentRecord.contact.last_name;
        t.defaultModel = that.defaultModel;
        t.data_object.schema.properties.customer_name.hideInTable = true;
        t.data_object.schema.properties.customer_name.hideInTableFn = "";
        t.data_object.object_name = "storage";
        t.data_object.object_name_to_update = "storage";

        //
      }
    });
    this.$root.$on("customBtnClick", (b) => {
      console.log(b);
    });
    // this.$root.$on("mainTabChanged", (t) => {
    //   console.log(t);
    // });
    this.$root.$on("tableSelectionChanged", (obj) => {
      if (obj.table_title == "Departments") {
        that.department = "";
        if (obj.selected.length && obj.selected[0]) {
          that.department = obj.selected[0].department_name;
        }
      }
    });

    this.$root.$on("tableEditRecord", (t) => {
      // console.log(t);
      //
      if (t.tbl.tableName == "storage") {
        if (
          t.tbl.data_object.schema &&
          t.tbl.data_object.schema["v-bind"] &&
          !t.tbl.data_object.schema["v-bind"].schemaAdjusted
        ) {
          t.tbl.defaultModel = that.defaultModel;
          if (
            !that.currentRecord.department
            // &&
            // !that.currentRecord.department.length > 1
          ) {
            t.tbl.data_object.schema["v-bind"].mainTabs[0].hidden = true;
            Object.keys(t.tbl.data_object.schema.properties).forEach((k) => {
              if (
                (t.tbl.data_object.schema.properties[k] &&
                  t.tbl.data_object.schema.properties[k].tab) ||
                t.tbl.data_object.schema.properties[k].tab == 0
              ) {
                t.tbl.data_object.schema.properties[k].tab -= 1;
              }
            });
            t.tbl.data_object.schema["v-bind"].schemaAdjusted = true;
          } else {
            console.log(
              t.tbl.data_object.schema.properties.customer.properties
            );
            Object.keys(
              t.tbl.data_object.schema.properties.customer.properties
            ).forEach((k) => {
              if (k != "department") {
                t.tbl.data_object.schema.properties.customer.properties[
                  k
                ].hidden = true;
              }
            });
            // t.tbl.data_object.schema.properties
          }
        }

        // t.tbl.data_object.schema.properties.customer.hidden = true;

        // t.tbl.mainTab = 1;
      }
      if (t.tbl.tableName == "customers" && t.rec) {
        this.$root.$on("tableInit", (s) => {
          console.log(s);
          if (s.vBind && s.vBind.tableName == "customer_shipments") {
            s.initialQry = { customer_id: t.rec._id };
            s.data_object = {
              ...s.data_object,
              ...{
                object_name: "v_customer_shipments",
                schema_name: "customer_shipments",

                qry: s.initialQry,
                id_fields: ["customer_id"],
              },
            };
          }
        });
        that.currentRecord = t.rec;
        t.rec.address = t.rec.address.filter((a) => {
          return !a.existing_address && a.location && a.location.address;
        });

        var data = {
          object_name: "v_shipment_letter_fields",
          // schema_name: "v_customer_fields",

          qry: { customer_id: t.rec._id },
          id_fields: ["customer_id"],
        };
        data.additional_data = [
          {
            obj_name: "storage",
            qry: { customer: t.rec._id },
            id_fields: ["customer"],
          },
        ];
        var tbl = this.$refs.customerTable;
        // tbl.loading = true;
        // axios
        //   .post(this.serverURL + "/get_data", data, {
        //     withCredentials: true,
        //   })
        //   .then((r) => {
        //     console.log(r.data);
        //     t.rec.storage = r.data.additional_model.storage;
        //     t.rec.customer_shipments = r.data.model;

        //     t.rec.customer_shipments.forEach((s) => {
        //       s.stops = [];
        //       try {
        //         s.service.shipment_stop.forEach((a) => {
        //           s.stops.push(a.value + ": " + a.full_address);
        //         });
        //       } catch {
        //         //
        //       }
        //       s.stops = s.stops.join();
        //       // s.origin_city = s.origin.city;
        //       // s.origin_state = s.origin.state;
        //       // s.origin_zip = s.origin.state;
        //       // s.destination_city = s.destination.city;
        //       // s.destination_state = s.destination.state;
        //       // s.destination_zip = s.destination.zip;
        //       // s.first_name = t.rec.first_name;
        //       // s.last_name = t.rec.last_name;
        //       // s.full_name = t.rec.full_name;
        //       s.company = t.rec.company;
        //     });
        //     tbl.loading = false;
        //     // t.tbl.initEdit(t.rec);
        //   });
      }
    });
    this.tableReady = true;
  },
  watch: {
    // Watch for route changes
    $route: "fetchData",
  },
  methods: {
    fetchData() {
      console.log("fetch data");
    },
    beforeSave(r, tbl) {
      r.storage = null;
      r.customer_shipments = null;
    },
    onDataReceived(data, tbl) {
      if (this.$root.customerId) {
        var mainTabs = [];
        var allowedTabs = [0, 7];
        allowedTabs.forEach((t) => {
          mainTabs.push(data.schema["v-bind"].mainTabs[t]);
        });
        data.schema["v-bind"].mainTabs = mainTabs;
        data.schema.properties.contact.properties.note.hidden = true;
        // data.schema["v-bind"].mainTabs = [
        //   data.schema["v-bind"].mainTabs[0],
        //   data.schema["v-bind"].mainTabs[7],
        // ];
        window.location.hash =
          "#/customer-detail/" + this.$root.customerId.$oid;
        // tbl.originalRecords = data.table;
        // tbl.schema.properties = data.schema;
        // tbl.initEdited(this.$root.customerId.$oid);
      }
      return data;
    },
    rowClick: function(item) {
      console.log(this.$root);
      // this.$root.addResentTab(item);

      console.log(item);
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },
  },
};
</script>
